import type { RouteObject } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/home/page";
import NewsList from "@/pages/news/page";
import ArticleDetail from "@/pages/article/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "article/:id", element: <ArticleDetail /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;